import updateState from '../components/geolocation';
// import TalkRealtor from '../components/modal/talk-realtor/index';
import { SearchToolbarDropdownController } from '../components/dropdown-controller';
import Detection from '../utils/detection';
import anime from 'animejs';

import Modal from './modal';

(function () {

  const arrow = document.getElementById('arrow');
  const selectState = document.getElementById('select-state');
  const btnOpenMenuMobile = document.getElementById('btn-toggle-menu');
  const btnCloseMenuMobile = document.getElementById('menu-close');
  const menuMobile = document.getElementById('menu-mobile');
  // const selectChangeState = document.getElementById("selector_state");
  const selectChangeStateMobile = document.getElementById("selector_state_mobile");

  if (btnOpenMenuMobile) btnOpenMenuMobile.addEventListener('click', showMenuMobile);
  if (btnCloseMenuMobile) btnCloseMenuMobile.addEventListener('click', hideMenuMobile);

  function showMenuMobile() {
    menuMobile.style.display = 'block';
  }

  function hideMenuMobile() {
    menuMobile.style.display = 'none';
  }

  let btnsChangeState = document.querySelectorAll('.btn-modal-change-state');

  Array.from(btnsChangeState).forEach(btn => {
    btn.addEventListener('click', function (event) {
      document.querySelectorAll(".page-region .btn-modal-change-state").forEach(function (btnRegion) {
        btnRegion.classList.add("loading");
      });
      $(this).children(".loading-img").addClass('clicked');
      updateState(this.getAttribute('data-change-state'), true);
    });
  });

  for (var i = 0; i < btnsChangeState.length; i++) {
    if (btnsChangeState[i].getAttribute('data-change-state') == window.state) {
      selectState.innerHTML = btnsChangeState[i].getAttribute('data-state-name') + arrow.outerHTML;
      break;
    }
  }
  if (selectChangeStateMobile) {
    for (var i = 0; i < selectChangeStateMobile.options.length; i++) {
      if (selectChangeStateMobile.options[i].value == window.state) {
        //     selectChangeState.options[i].selected = true;
        selectChangeStateMobile.options[i].selected = true;
        break;
      }
    }


    // selectChangeState.addEventListener('change', function (event) {
    //   console.log("selectChangeState")
    //   updateState(this.value, true);
    // });
    selectChangeStateMobile.addEventListener('change', function (event) {
      updateState(this.value, true);
    });
  }

  const detection = new Detection();
  // const selectors = {
  //     btnRealtor: '.btn-online-realtor'
  // }


  if (detection.isMotoGPlay()) {
    document.querySelector('.main-menu-block-items').classList.add('is-3-columns');
  }

  const selectSP = {
    buttonId: 'search-menu-block-button-sp',
    dropdownIds: {
      state: 'search-menu-block-state',
      regions: 'search-menu-block-regions-sp',
      type: 'search-menu-block-type-sp'
    },
    data: {
      state: '',
      regions: '',
      type: ''
    }
  };

  const selectRJ = {
    buttonId: 'search-menu-block-button-rj',
    dropdownIds: {
      state: 'search-menu-block-state',
      regions: 'search-menu-block-regions-rj',
      type: 'search-menu-block-type-rj'
    },
    data: {
      state: '',
      regions: '',
      type: ''
    }
  };

  new SearchToolbarDropdownController('/busca', selectSP);
  new SearchToolbarDropdownController('/busca', selectRJ);


  const oferecaTerreno = document.querySelectorAll('.ofereca-terreno');

  const modalOferecaTerreno = new Modal('#modal-ofereca-terreno', false);

  if (oferecaTerreno) {
    oferecaTerreno.forEach(elemento => {
      elemento.addEventListener('click', function () {
        fnCloseMenu();
        modalOferecaTerreno.openModal();
      })
    });
   
    document.getElementById('close-modal-ofereca-terreno').addEventListener('click', function () {
      modalOferecaTerreno.closeModal();
    });

    var opcoes = document.querySelectorAll('#modal-ofereca-terreno .btn-state');

    for (var i = 0; i < opcoes.length; i++) {

      opcoes[i].addEventListener('click', function () {
        document.querySelector('#modal-ofereca-terreno .subtitle').innerHTML =
          'em <b>' + this.dataset.uf_texto + '</b>';
        document.querySelector('#modal-ofereca-terreno .cidades').style.display = "none";
        document.querySelector('#modal-ofereca-terreno .contato').style.display = "block";

        if (this.dataset.exibir_chat == 1) {
          // clique para abrir o chat
          document.querySelector('#modal-ofereca-terreno .cadastrar').style.display = "block";
          var link = document.querySelector('#modal-ofereca-terreno .cadastrar a');
          link.href = link.dataset.link + '&uf=' + this.dataset.uf;
        }

        const linkContato = document.querySelector('#modal-ofereca-terreno .contato a');

        linkContato.href = "mailto:" + this.dataset.email;
        linkContato.innerHTML = this.dataset.email;

      });
    }
  }

  const fnCloseMenu = function () {
    document.body.classList.remove('opened-menu');
    document.body.classList.remove('opened-search-menu');
    document.documentElement.classList.remove('opened-search-menu');
    document.body.classList.add('menu-closing');

    window.setTimeout(() => {
      document.body.classList.remove('menu-closing');
    }, 200);
  }

  if (document.getElementById('site-header') === null) {
    return;
  }
  // console.log("3")
  let SearchBox = {
    timeInterval: null,
    prevState: null,
    setSize: function () {
      let styleMenuBlock = window.getComputedStyle(document.querySelector('.search-menu-block'), null);
      let boxHeight = parseInt(styleMenuBlock.getPropertyValue('height'));
      let viewportHeight = window.innerHeight;
      let elemSearchBg = document.querySelector('.search-menu-block .search-bg');
      let currentState = boxHeight > viewportHeight;

      if (currentState === SearchBox.prevState) {
        return;
      }

      SearchBox.prevState = currentState;

      if (currentState) {
        elemSearchBg.style.height = `calc(${viewportHeight}px - 355px)`;
      } else {
        elemSearchBg.style.height = 'calc(100vh - 355px)';
      }
    },
    setInterval: function () {
      SearchBox.timeInterval = setInterval(function () {
        SearchBox.setSize();
      }, 50);
    },
    clearInterval: function () {
      clearInterval(SearchBox.timeInterval);
    }
  };

  // Array.prototype.slice
  //     .call(document.querySelectorAll(selectors.btnRealtor))
  //     .map(item => {
  //         item.addEventListener('click', (evt) => {
  //             evt.preventDefault();

  //             const origin = evt.currentTarget.dataset.origin;
  //             const modal = new TalkRealtor(origin);
  //             modal.openModal();
  //         });
  //     });

  const openMenu = document.getElementById('open-menu');
  if (openMenu) {
    openMenu.addEventListener('click', function (evt) {
      evt.preventDefault();
      document.body.classList.add('opened-menu');
    });
  }

  const openSearchMenu = document.getElementById('open-search-menu');
  if (openSearchMenu) {
    openSearchMenu.addEventListener('click', function () {
      document.body.classList.add('opened-search-menu');
      document.documentElement.classList.add('opened-search-menu');

      SearchBox.setSize();
      SearchBox.setInterval();
    });
  }

  if (document.getElementById('whatsapp-menu')) {
    document.getElementById('whatsapp-menu').addEventListener('click', function (event) {
      event.preventDefault();

      let url = `https://api.whatsapp.com/send?phone=${window.whatsappNumber}`;

      if (this.classList.contains('btn-whatsapp-link')) {
        url = this.getAttribute('href');
      }

      GTM('gaTriggerEvent', 'clique', 'whatsapp', 'whatsapp_topo');
      window.open(url, '_blank');
    });
  }



  const closeMenu = document.getElementById('close-menu');
  if (closeMenu) {
    closeMenu.addEventListener('click', fnCloseMenu);
  }





  const closeSearchMenu = document.getElementById('close-search-menu');
  if (closeSearchMenu) {
    document.getElementById('close-search-menu').addEventListener('click', function () {
      document.body.classList.remove('opened-menu');
      document.body.classList.remove('opened-search-menu');
      document.documentElement.classList.remove('opened-search-menu');
      document.body.classList.add('search-menu-closing');

      SearchBox.clearInterval();

      window.setTimeout(() => {
        document.body.classList.remove('search-menu-closing');
      }, 200);
    });
  }

  document.addEventListener('keyup', function (event) {
    if (event.defaultPrevented) {
      return;
    }

    const key = event.key || event.keyCode;

    if (key === 'Escape' || key === 'Esc' || key === 27) {
      if (document.body.classList.contains('opened-menu')) {
        document.getElementById('close-menu').click();
      } else if (document.body.classList.contains('opened-search-menu')) {
        document.getElementById('close-search-menu').click();
      }
    }
  });

  // Buttons

  document.querySelectorAll('.site-change-button').forEach((btnChange) => {
    btnChange.addEventListener('click', function (event) {
      event.preventDefault();
      let stateTo = this.getAttribute('href').replace('#', '');
      updateState(stateTo);
    });
  });

  // document.getElementById('site-change-button').addEventListener('click', function (event) {
  //     event.preventDefault();
  //     updateState(window.state == 'SP' ? 'RJ' : 'SP');
  // });

  // Modal select state



  const linkToTopLp = document.querySelector('header .link-to-top-lp');
  if (linkToTopLp) {
    linkToTopLp.addEventListener('click', function (e) {
      e.preventDefault();

      anime({
        targets: window.document.scrollingElement || window.document.body || window.document.documentElement,
        scrollTop: 0,
        duration: 500,
        easing: 'easeInOutQuad'
      });
    });
  }

})();

function whatsappEvent() {
  // GTM('gaTriggerEvent', 'clique', 'whatsapp', 'whatsapp_topo');
}
